import React from "react";

export interface TPlusIconProps extends React.SVGAttributes<SVGElement> {
  fill?: string;
}

export function PlusIcon({ fill = "currentColor", ...rest }: TPlusIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M16 7V9L0 9L8.74224e-08 7L16 7Z" fill={fill} />
      <path d="M9 16H7L7 0L9 1.74846e-07L9 16Z" fill={fill} />
    </svg>
  );
}
